import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
import '../../../modules/contacts/register-panels'
import { ContactFullPage } from '../../../modules/contacts/contact-full-page'

const detailSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
})

/** The full-page contact record at /contacts/:id. */
export const Route = createFileRoute('/_authed/contacts/$contactId')({
  validateSearch: detailSearchSchema,
  component: ContactDetailRoute,
})

function ContactDetailRoute() {
  const { contactId } = Route.useParams()
  return <ContactFullPage contactId={contactId} />
}
